<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Listagem de Contratos
      </p>
    </div>
    <div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-3">
          Unidade:
          <lista-unidades-select
            class="input-new-design"
            :todos="temPermissaoTodasUnidades"
            v-model="filtros.unidade"
          ></lista-unidades-select>
        </div>
        <div class="col-md-3 q-ml-sm">
          <div class="col-12 col-md-6">
            <SelecaoFornecedorContrato
              :hiden-label="true"
              class="input-new-design"
              :label-superior="'Fornecedor'"
              @enviarFornecedor="receberFornecedor"
            />
          </div>
        </div>

        <div class="col-md-3 q-ml-sm">
          Número Contrato:
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.contrato"
          />
        </div>
      </div>

      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-3">
          <div class="col-md-2">Tipo Fornecimento</div>
          <q-select
            v-model="filtros.tipoFornecimento"
            class="input-new-design"
            dense
            outlined
            use-input
            @filter="filterFn"
            :options="suppliesOptions"
            option-label="name"
            option-value="name"
            placeholder="Selecione o tipo de fornecimento"
          />
        </div>
        <div class="col-md-3 q-ml-sm">
          <div class="col-md-2">Status</div>
          <q-select
            v-model="filtros.status"
            class="input-new-design"
            option-label="name"
            option-value="code"
            label-color="grey-6"
            :options="statusOptions"
            dense
            outlined
          />
        </div>

        <div class="col-md-1 q-ml-sm q-mt-lg row items-center">
          <q-btn
            @click="getDados()"
            icon="filter_alt"
            no-caps
            style="background-color: #7ab9e0; border-radius: 8px; color: white"
            label="Filtrar"
          />
        </div>
        <q-btn
          no-caps
          icon="add"
          class="q-mt-lg"
          style="
            background-color: #58c16d;
            border-radius: 8px;
            color: white;
            height: 37px;
          "
          label="Criar Novo Contrato"
          @click="adicionarContrato"
        />
      </div>

      <!-- Modal: usuário sem permissão e sem unidade selecionada -->
      <dialog-info-design
        mensagem="Selecione uma Unidade para continuar"
        sub-mensagem="Por favor, selecione uma Unidade no filtro antes de prosseguir."
        :exibir="modalSelecioneUnidade"
        :esconder-confirme="true"
        :show-cancelar="true"
        @resultado="modalSelecioneUnidade = false"
      />

      <template v-if="temPermissaoTodasUnidades || filtros.unidade?.id">
        <q-table
          flat
          table-header-class="bg-accent text-width-bold"
          :rows="rows"
          :loading="disable"
          dense
          :columns="columns"
          v-model:pagination="pagination"
          class="tabela-tamanho-fixo q-mt-md"
          row-key="name"
          hide-pagination
          @request="handleRequest"
        >
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
            >
              Contratos Criados
            </span>
          </template>

          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>

          <template #body-cell-startDate="props">
            <q-td :props="props">
              {{ formatDate(props.value) }}
            </q-td>
          </template>

          <template #body-cell-endDate="props">
            <q-td :props="props">
              {{ formatDate(props.value) }}
            </q-td>
          </template>

          <template #body-cell-totalValue="props">
            <q-td :props="props">
              {{ formatCurrency(props.value) }}
            </q-td>
          </template>

          <template #body-cell-status="props">
            <q-td :props="props">
              <q-chip
                :color="getStatusColor(props.value)"
                text-color="white"
                :label="props.value"
                size="sm"
              />
            </q-td>
          </template>

          <template #body-cell-detalhe="props">
            <q-td class="text-center">
              <q-btn
                round
                dense
                flat
                color="primary"
                icon="visibility"
                @click="verDetalhe(props.row)"
              />
            </q-td>
          </template>

          <template #body-cell-excluir="props">
            <q-td class="text-center">
              <q-btn
                round
                dense
                flat
                color="negative"
                icon="delete"
                @click="(deletarDialog = true), (linhaParaAcao = props.row)"
              />
            </q-td>
          </template>
        </q-table>
        <div v-if="rows.length != 0" class="row justify-start q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </template>
    </div>

    <!-- Modal Adicionar Contrato -->
    <ModalAdicionarContrato
      v-model="showModalContrato"
      @contrato-created="handleContratoCreated"
    />

    <dialog-info-design
      mensagem="Deletar Contrato?"
      subMensagem="Tem certeza que deseja deletar o contrato?"
      :exibir="deletarDialog"
      :showCancelar="true"
      @resultado="excluirContrato"
    />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "contractNumber",
    label: "Número do Contrato",
    field: "contractNumber",
    align: "left",
    sortable: true,
  },
  {
    name: "provider",
    label: "Fornecedor",
    field: (row) => row.provider?.fantasyName || row.provider?.businessName,
    align: "left",
    sortable: true,
  },

  {
    name: "cnpj",
    label: "CNPJ",
    field: (row) => row.provider?.cnpj,
    align: "left",
    sortable: true,
    format: (val) => {
      if (!val) return "-";
      return val
        .replace(/\D/g, "")
        .replace(/^(\d{2})(\d)/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1/$2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .substring(0, 18);
    },
  },

  {
    name: "tipo",
    label: "Tipo Fornecimento",
    field: (row) => row?.supplyName,
    align: "left",
    sortable: true,
  },

  {
    name: "startDate",
    label: "Data Início",
    field: "startDate",
    align: "center",
    sortable: true,
  },
  {
    name: "endDate",
    label: "Data Fim",
    field: "endDate",
    align: "center",
    sortable: true,
  },
  {
    name: "totalValue",
    label: "Valor Total",
    field: "totalValue",
    align: "right",
    sortable: true,
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "center",
    sortable: true,
  },
  {
    name: "detalhe",
    label: "Detalhe",
    field: (row) => row,
    align: "center",
  },
  {
    name: "excluir",
    label: "Excluir",
    field: (row) => row,
    align: "center",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";
import SelecaoFornecedorContrato from "../components/SelecaoFornecedorContrato.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import ModalAdicionarContrato from "../components/ModalAdicionarContrato.vue";
import DialogInfoDesign from "../../../components/DialogInfoDesign.vue";
import { watchDebounced } from "@vueuse/core";
import { usuarioTemPermissao } from "../../../helpers/permissaoHelper";

export default {
  components: {
    ListaUnidadesSelect,
    SelecaoFornecedorContrato,
    ModalAdicionarContrato,
    DialogInfoDesign,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const modalSelecioneUnidade = ref(false);
    const statusOptions = ref([
      "Todos",
      "Vigente",
      "Vencido",
      "Deletado",
      "Atendido",
    ]);
    const suppliesOptions = ref([]);
    const deletarDialog = ref(false);
    const showModalContrato = ref(false);
    const linhaParaAcao = ref(null);
    const time = ref(null);
    const filtros = ref({
      contrato: "",
      unidade: "",
      fornecedor: "",
      status: "Todos",
      tipoFornecimento: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const temPermissaoTodasUnidades = computed(() =>
      usuarioTemPermissao(store, "visualizar_todas_unidades")
    );

    const getDados = async (page = 0, rowsPerPage = 15) => {
      if (!temPermissaoTodasUnidades.value && !filtros.value.unidade?.id) {
        modalSelecioneUnidade.value = true;
        disable.value = false;
        return;
      }

      try {
        let response = await store.dispatch("gdcStore/getContratos", {
          vendorId: filtros.value?.unidade?.id,
          providerId: filtros.value?.fornecedor?.id,
          contractNumber: filtros.value?.contrato,
          supplyName: filtros.value?.tipoFornecimento?.name,
          status:
            filtros.value?.status == "Todos"
              ? undefined
              : filtros.value?.status,
          page: page,
          perPage: rowsPerPage,
        });

        rows.value = response.data.result.data;

        pagination.value.page = response.data.result.currentPage;
        pagination.value.rowsPerPage = response.data.result.perPage;
        pagination.value.rowsNumber = response.data.result.total;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarContrato = () => {
      showModalContrato.value = true;
    };

    const handleContratoCreated = (contratoData) => {
      console.log("Contrato criado:", contratoData);
      getDados(pagination.value.page, pagination.value.rowsPerPage);

      quasar.notify({
        message: `Contrato ${contratoData.numeroContrato} processado com sucesso!`,
        color: "positive",
        position: "bottom",
        timeout: 3000,
        icon: "check_circle",
      });
    };

    const verDetalhe = (row) => {
      router.push({
        name: "detalhe-contrato",
        params: { id: row.id },
      });
    };

    const excluirContrato = async (resultado) => {
      deletarDialog.value = false;
      if (resultado) {
        try {
          await store.dispatch("gdcStore/excluirContrato", {
            contratoId: linhaParaAcao.value.id,
          });

          quasar.notify({
            message: "Contrato excluida com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados(pagination.value.page, pagination.value.rowsPerPage);
        } catch (error) {
          quasar.notify({
            message: "Erro ao excluir Contrato",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    onMounted(() => {
      if (store.state.org.unidadeData?.id) {
        filtros.value.unidade = store.state.org.unidadeData;
      }
      getDados();
    });

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        filtros.value.unidade = JSON.parse(getunidade);
      } else if (!temPermissaoTodasUnidades.value) {
        filtros.value.unidade = { id: "", nome: "" };
      }
    };

    onMounted(getUnidade);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const receberFornecedor = (value) => {
      filtros.value.fornecedor = value;
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        filtros.value.unidade = store.state.org.unidadeData;
      }
    );

    watchDebounced(
      () => filtros.value,
      () => {
        disable.value = true;
        handleRequest();
      },
      { debounce: 1000, deep: true }
    );

    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR");
    };

    const formatCurrency = (value) => {
      if (value === null || value === undefined) return "R$ 0,00";
      const truncatedValue = Math.floor(value * 100) / 100;
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(truncatedValue);
    };

    const getStatusColor = (status) => {
      const statusColors = {
        VIGENTE: "positive",
        VENCIDO: "negative",
        SUSPENSO: "warning",
        CANCELADO: "negative",
        "EM ANÁLISE": "info",
      };
      return statusColors[status] || "grey";
    };

    const carregarSupplies = async (val) => {
      try {
        const response = await store.dispatch("gdcStore/getSupplies", {
          name: val,
        });
        suppliesOptions.value = response.data.result.data || [];
      } catch (error) {
        console.error("Erro ao carregar tipos de fornecimento:", error);
      }
    };
    onMounted(carregarSupplies);

    const filterFn = (val, update) => {
      clearTimeout(time.value);
      time.value = setTimeout(() => {
        update(async () => {
          await carregarSupplies(val);
        });
      }, 300);
    };

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      filterFn,
      time,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      disable,
      temPermissaoTodasUnidades,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      receberFornecedor,
      deletarDialog,
      statusOptions,
      linhaParaAcao,
      showModalContrato,
      adicionarContrato,
      handleContratoCreated,
      verDetalhe,
      excluirContrato,
      formatDate,
      formatCurrency,
      getStatusColor,
      suppliesOptions,
      carregarSupplies,
      modalSelecioneUnidade,
    };
  },
};
</script>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
